import React from "react";

import { TIMEOUT_ALERT_IN_SECUNDES } from "config";

//place: ["tl", "tc", "tr", "bl", "bc", "br"]
//type: ["primary", "success", "danger", "warning", "info"]
const notification = (place, type, message, notificationAlertRef) => {
    var options = {};
    options = {
        place: place,
        message: (
        <div>
            <div>
                {message}
            </div>
        </div>
        ),
        type: type,
        // icon: "nc-icon nc-bell-55",
        autoDismiss: TIMEOUT_ALERT_IN_SECUNDES,
    };
    if(notificationAlertRef
        && notificationAlertRef.current) {
            notificationAlertRef.current.notificationAlert(options);
    }
};
const error = (error, notificationReference, message) => {
    //TODO: [Dobri]Error notification here
    if(!notificationReference) {
        return;
    }
    if(message){
        return notification("br", "danger", message, notificationReference);
    }
    notification("br", "danger", "Се случи комуникациска грешка. Обидете се повторно.", notificationReference);
}

const success = (data, notificationReference) => {

    //TODO: [Dobri]success notification here
    if(notificationReference)
        notification("br", "success", data, notificationReference);

}

const info = (data, notificationReference) => {

    //TODO: [Dobri]info notification here
    if(notificationReference)
        notification("br", "info", data, notificationReference);

}

const warning = (data, notificationReference) => {

    //TODO: [Dobri]warning notification here
    if(notificationReference)
        notification("br", "warning", data, notificationReference);

}

const notificationManager = { notification, success, info, warning, error }
export default notificationManager;